





































































import { Component, Vue, Prop } from 'vue-property-decorator';

// код целевого шага agreement_status -> вид действия; подтверждения — целиковые фразы, а не склейка с названием кнопки
const STEP_ACTIONS: { [code: number]: string } = { 5: 'send', 6: 'rework', 20: 'approve', 30: 'approve', 36: 'approve', 62: 'approve' };

const PHRASES: { [group: string]: { [action: string]: string } } = {
    confirm: {
        send: 'modules.budget_request.budget_programs.action.confirm_send',
        approve: 'modules.budget_request.budget_programs.action.confirm_approve',
        rework: 'modules.budget_request.budget_programs.action.confirm_rework'
    },
    saveFirst: {
        send: 'modules.budget_request.budget_programs.action.save_first_send',
        approve: 'modules.budget_request.budget_programs.action.save_first_approve'
    },
    blocked: {
        send: 'modules.budget_request.budget_programs.action.blocked_send',
        approve: 'modules.budget_request.budget_programs.action.blocked_approve'
    }
};

@Component
export default class CActionModal extends Vue {
    @Prop({
        required: true,
        default: []
    })
    private aggHistory!: any[];
    @Prop({
        required: true,
        default: []
    })
    private agrCodesDict!: any[];
    @Prop({
        required: true,
    })
    private aggrLevelCode!: number;
    @Prop({
        required: true,
    })
    private brbpCode!: number;
    @Prop({
        required: true,
    })
    private saveConclStep!: Function;
    @Prop({
        required: true,
    })
    private getCurrStep!: string;
    @Prop({
        required: true,
    })
    private fieldLocalName!: any;
    @Prop({
        required: true,
    })
    private disableConclBtns!: Boolean;
    @Prop({
        required: true,
    })
    private canMoveForward!: Boolean;
    @Prop({
        required: true,
    })
    private dataChanged!: Boolean;
    @Prop({
        required: true,
    })
    private conclMode!: Boolean;
    @Prop({
        required: true,
        default: []
    })
    private errors!: any[];
    
    private commentText: string | null = null;

    mounted() {
        this.$root.$on('bv::modal::shown', () => {
            const elem = this.$refs.actionBlock as HTMLElement;
            if (elem && elem.lastElementChild) elem.lastElementChild.scrollIntoView()
        })
    }

    // получаем от какого шага к которому был переход
    private getCurrAction(item: any, idx: number) {
        let curr_step = 1;
        if (idx > 0) {
            curr_step = parseInt(this.aggHistory[idx - 1].approveStatus);
        } 
        const next_step = parseInt(item.approveStatus);
        const curr_step_obj = this.agrCodesDict.filter(curr => curr.code === curr_step)
        const next_step_obj = this.agrCodesDict.filter(next => next.code === next_step)

        let text = '';
        if (curr_step_obj.length) {
            text = this.locName(curr_step_obj[0])
        }
        if (next_step_obj.length) {
            text += ` -> ${this.locName(next_step_obj[0])}`
        }
        return text
        
    }
    
 
    

    // в agreement_status пустые названия встречаются и как строка 'None'
    private locName(obj: any, kkField = 'name_kk', ruField = 'name_ru'): string {
        if (!obj) { return ''; }
        const filled = (v: any) => (v && v !== 'None' ? v : '');
        return (this.$i18n.locale === 'kk' && filled(obj[kkField])) || filled(obj[ruField]);
    }

    private get currStepName(): string {
        return (this.currStep && this.locName(this.currStep)) || this.getCurrStep;
    }

    // получаем цвет для перехода
    private labelColor(item: any, idx: number) {
        if (idx === 0) return 'forward';
        const prev_step = parseInt(this.aggHistory[idx - 1].approveStatus); // куда перешел с предыдущего шага
        const prevConclDictItem = this.agrCodesDict.filter((concl: any) => concl.code === prev_step)[0]
        if (prevConclDictItem && prevConclDictItem.next_step === parseInt(item.approveStatus)) return 'forward';
        if (parseInt(item.approveStatus) === 1) return 'reset';
        return null

    }

    // Объект текущего шага
    private get currStep() {
       if (!this.aggrLevelCode || !this.agrCodesDict.length) return null;
       const curr = this.agrCodesDict.filter((item: any) => item.code === this.aggrLevelCode)
       if (curr.length) return curr[0];
       return null;
    }

    //обработка кликов по кнопке 
    private requestText = ''; 
    private actionFunc: any ;
    private dasableNextBtn = false;
    private action: string = '';
    private btnClickHandler(action: string) {
        if (this.dataChanged) {
            this.dasableNextBtn = true;
            this.requestText = action === 'forward'
                ? this.requestPhrase('saveFirst', this.forwardStep)
                : this.$t('modules.budget_request.budget_programs.action.save_first') as string;
        } else if (!this.canMoveForward && action === 'forward' && this.conclMode) {
            this.dasableNextBtn = true;
            this.requestText = this.requestPhrase('blocked', this.forwardStep);
        } else {
            this.dasableNextBtn = false;
            switch (action) {
                case 'forward':
                    this.requestText = this.requestPhrase('confirm', this.forwardStep);
                    break;
                case 'backword':
                    this.requestText = this.requestPhrase('confirm', this.backwardStep);
                    break;
                default: ''
            }
        }
        
        this.action = action;
        this.$bvModal.show('action-modal-button');
    }

    private requestPhrase(group: string, step: any): string {
        const btnName = this.locName(step, 'btn_name_kk', 'btn_name_ru');
        const kind = step ? STEP_ACTIONS[step.code] : undefined;
        const key = kind ? PHRASES[group][kind] : undefined;
        return key ? this.$t(key) as string : btnName;
    }

    // добавление записи в историю изменения статусов
    private addComment() {
        if (!this.brbpCode) return;
        const newObj = {
            budgetRequestBp: this.brbpCode,
            noteRu: this.commentText
        };
         
        const curStepObj = this.agrCodesDict.find(itm => itm.code === this.aggrLevelCode)
        switch (this.action) {
            case 'forward':
                if (curStepObj) {
                    this.$set(newObj, 'approveStatus', curStepObj.next_step)
                }
                break;
            case 'backword': 
                if (curStepObj) {
                    this.$set(newObj, 'approveStatus', curStepObj.prev_step)
                }
                break;
            case 'reset': 
                this.$set(newObj, 'approveStatus', "1")
                break;
            default: ''
        }
        this.saveConclStep(newObj)
        // this.aggHistory.unshift(newObj)
        this.commentText = ''
        this.$bvModal.hide('slot-modal');
    }

    //получаем названия кнопок
    private get backwardStep() {
        if (!this.currStep || !this.currStep.prev_step || !this.agrCodesDict.length) return null;
        return this.agrCodesDict.find((item: any) => item.code === this.currStep.prev_step) || null
    }

    private get forwardStep() {
        if (!this.currStep || !this.currStep.next_step || !this.agrCodesDict.length) return null;
        return this.agrCodesDict.find((item: any) => item.code === this.currStep.next_step) || null
    }

    private get backwardBtnName() {
        return this.locName(this.backwardStep, 'btn_name_kk', 'btn_name_ru') || null
    }

    private get forwardBtnName() {
        return this.locName(this.forwardStep, 'btn_name_kk', 'btn_name_ru') || null
    }
    // деактивация кнопок на первом и последнем шаге
    private get showBackward() {
        if (!this.currStep) return true;
        return Boolean(this.currStep.prev_step);
    }

    private get disableForward() {
        if (!this.currStep) return true;
        return !Boolean(this.currStep.next_step);
    }
}
